import BannerTerminated from './BannerTerminated';

export default BannerTerminated;